var _circle, _path, _rect, _path2, _rect2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgPhysical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  const _id2 = useUniqueInlineId();
  const _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16,
    r: 16,
    fill: "#F2D9F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 15a.5.5 0 0 1 .5-.5H8v3H6.5A.5.5 0 0 1 6 17v-2Z",
    fill: "#963695",
    stroke: "#963695"
  })), /*#__PURE__*/React.createElement("mask", {
    id: _id,
    fill: "#fff"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 9,
    width: 7,
    height: 14,
    rx: 1
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 9,
    width: 7,
    height: 14,
    rx: 1,
    stroke: "#963695",
    strokeWidth: 4,
    mask: "url(#".concat(_id, ")")
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#963695",
    stroke: "#963695",
    d: "M14 14.5h5v3h-5z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: _id2,
    fill: "#fff"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 9,
    width: 7,
    height: 14,
    rx: 1
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 9,
    width: 7,
    height: 14,
    rx: 1,
    stroke: "#963695",
    strokeWidth: 4,
    mask: "url(#".concat(_id2, ")")
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 14.5h1.5a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5H25v-3Z",
    fill: "#963695",
    stroke: "#963695"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhysical);
export default __webpack_public_path__ + "static/media/physical.5d3e6abf0866ef426170fdd2538bf6e7.svg";
export { ForwardRef as ReactComponent };